/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable linebreak-style */
/* eslint-disable wrap-iife */
/* eslint-disable no-inner-declarations */
/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { useAmp } from 'next/amp';
import Router, { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import useEventListener from 'root/hooks/useEventListener';
import isBrowser from 'utils/isBrowser';
import map from 'base-ui/dist/underline/map';
import throttle from 'base-ui/dist/underline/throttle';
import get from 'base-ui/dist/underline/get';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};
const googleAnalytics = get(publicRuntimeConfig, 'settings.metrics', [publicRuntimeConfig.analytics_id] || [publicRuntimeConfig.GOOGLE_ANALYTICS_ID]);

const GoogleAnalyticsEvent = ({ analytics }) => {
  const isAmp = useAmp();
  const router = useRouter();
  if (isAmp) {
    googleAnalytics.filter((v) => (!v.name || v.name === 'analytics') && v.events).map((v) => (
      <amp-analytics key={v.codeId} type="googleanalytics" data-credentials="include">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: `
          {
            "vars": {
              "account": "${v.codeId}"
            },
            "triggers": {
              "click on [data-with-google-events='true'] trigger": {
                "on": "click",
                "selector": "[data-with-google-events='true']",
                "request": "event",
                "vars": ${JSON.stringify({ action: 'click', category: 'Button', value: 'Post' })}
              }
            }
          }`,
          }}
        />
      </amp-analytics>
    ));
  }

  const [registerNewEventLister, setRegisterNewEventLister] = useState(true);

  const sendGAEvent = throttle((gdata) => {
    analytics.event(gdata);
  }, 300);

  const registerEventLister = () => {
    if (isBrowser() && registerNewEventLister && analytics) {
      setRegisterNewEventLister(false);
      const handler = (type, data) => {
        analytics[type === 'social' ? 'eventSocial' : 'event']({ ...data });
      };

      const scrollHandler = () => {
        const h = document.documentElement;
        const b = document.body;
        const st = 'scrollTop';
        const sh = 'scrollHeight';

        const percent = parseInt(((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100, 10);
        const data = {
          action: 'scrolling',
          label: router.route,
          value: router.asPath,
          nonInteraction: 1
        };
        if (percent === 25) {
          sendGAEvent({ category: 'Scroll 25%', ...data });
        }
        if (percent === 50) {
          sendGAEvent({ category: 'Scroll 50%', ...data });
        }
        if (percent === 75) {
          sendGAEvent({ category: 'Scroll 75%', ...data });
        }
      };

      function domReady(cb) {
        let searchElements = true;
        (async function checkDomReady() {
          const state = document.readyState;
          const elements = await document.querySelectorAll('[data-with-google-events="true"]');
          if (elements.length && (state === 'loaded' || state === 'complete') && searchElements) {
            searchElements = false;
            map(elements, (el) => {
              if (el) cb(el, JSON.parse(el.getAttribute('data-google-events')));
            });
          } else {
            setTimeout(checkDomReady, 2500);
          }
        })();
      }

      domReady((el, g) => {
        useEventListener('click', () => handler(g.type, g.data), el);
      });
      useEventListener('scroll', () => scrollHandler());
    }
  };

  useEffect(() => {
    const handleRouteChangeComplete = () => {
      setRegisterNewEventLister(true);
    };
    Router.events.on('routeChangeComplete', handleRouteChangeComplete);
    return () => {
      Router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);
  registerEventLister();
  return null;
};

GoogleAnalyticsEvent.propTypes = {
  analytics: PropTypes.object,
};

export default GoogleAnalyticsEvent;
